/**
 * Woocommerce related scripts here.
 *
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Export the class reference.
 */
export default class Woocommerce {

    /**
     * Cache dom elements for use in the class's methods
     *
     * @return {void}
     */
    cache() {

        // Document body.
        this.$body = $( 'body' );

        // Badge
        this.$cartTotalBadge = $( '.js-shopping-cart-total' );

        // Form
        this.$form = null;

        // Notifications
        this.$addToCartNotification  = $( '#js-add-to-cart-notification' );
        this.$addToCartNotifications = this.$addToCartNotification.children();
        this.cartSuccess             = $( '#js-cart-success' );
        this.cartError               = $( '#js-cart-error' );
        this.cartStockError          = $( '#js-cart-stock-error' );
        this.checkoutRequiredField   = $( '.form-row.validate-required' );

        // Checkout
        this.checkoutAccountInfoTrigger = $( '.js-wc-checkout-account-info-trigger' );
        this.checkoutAccountInfoText    = $( '.js-wc-checkout-account-info-text' );
    }

    /**
     * All common events
     *
     * @return {void}
     */
    events() {
        // Handle submit.
        $( 'body' ).on( 'click', '.js-add-to-cart', ( e ) => {

            this.$form = $( e.currentTarget.closest( 'form' ) );

            if ( ! this.$form.length ) {
                return;
            }

            this.handleFormSubmit();

            return false;

        });
    }

    /**
     * HandleFormSubmit
     *
     */
    handleFormSubmit() {
        // Cart total
        this.updateCartNotification();

        // Init variables
        const $form = this.$form;
        const type  = 'post';
        const url   = $form.attr( 'action' );

        /**
         * Form data.
         *
         * Possible values CartController.php add_to_cart( $request ):
         * 'id'             => 0,
         * 'quantity'       => 1,
         * 'variation'      => [],
         * 'cart_item_data' => [],
         */
        const formData = $form.serializeArray();
        const data     = {};
        const nonce    = $form.data( 'nonce' );

        // Format data for the endpoint desired format.
        formData.forEach( element  => {

            // Variations
            if ( element.name === 'variation' ) {
                data[element.name] = JSON.parse( element.value );
            }
            // Other values:
            // id, quantity, cart_item_data.
            else {
                data[element.name] = element.value;
            }
        });

        // Submit button.
        const $formButton = $form.find( '.js-add-to-cart' );

        // Do the ajax
        // You can debug this here CartAddItem.php get_route_post_response()
        // And CartController.php add_to_cart()
        $.ajax( {
            type,
            url,
            data,
            dataType: 'json',
            headers: {
                'X-WC-Store-API-Nonce': nonce,
                'Nonce': nonce,
            },
            beforeSend: ( response ) => {
                $formButton.addClass( 'loading' );
            },
            complete: ( response ) => {
                if ( response.status === 201 ) {
                    $( document.body ).trigger( 'added_to_shopping_cart', {
                        form: $form,
                        quantity: data.quantity
                    });
                }
                $formButton.removeClass( 'loading' );
                this.updateCartNotification( response );
            },
        });
    }

    /**
     * Update cart notification
     *
     * @param {object|null} response
     *
     * @return {void}
     */
    updateCartNotification( response = null ) {

        if ( ! this.$addToCartNotification.length ) {
            return;
        }

        if ( response === null ) {
            this.$addToCartNotification.addClass( 'cart-action-notication-is-hidden' );
            this.$addToCartNotifications.addClass( 'is-hidden' );

            return;
        }

        let notificationToShow = this.cartSuccess;

        if ( response.status === 201 ) {
            this.$cartTotalBadge.each( function () {
                $(this).text( response.responseJSON.items_count ?? '' );
            });
        }
        else {
            const responseCode = response.responseJSON.code ?? '';
            notificationToShow = responseCode === 'woocommerce_rest_cart_product_no_stock' ? this.cartStockError : this.cartError;
        }

        this.$addToCartNotification.removeClass( 'cart-action-notification-is-hidden' );
        notificationToShow.removeClass( 'is-hidden' );

        setTimeout(() => {
            this.$addToCartNotification.addClass( 'cart-action-notification-is-hidden' ).removeAttr( 'tabindex' );
        }, 5000);
    }

    /**
     * Run when the document is ready.
     *
     * @return {void}
     */
    docReady() {
        this.cache();
        this.events();
    }
}
